import axios from "axios";
import React, { useEffect, useState, useMemo, useContext } from "react";
import DataTable from "react-data-table-component";
import IconButton from "@material-ui/core/IconButton";
import DeleteIcon from "@material-ui/icons/Delete";
import AddIcon from "@material-ui/icons/Add";
import CloudDownloadIcon from "@material-ui/icons/CloudDownload";
import { Tooltip } from "@material-ui/core";
import HistoryIcon from "@material-ui/icons/History";
import CMDeleteModal from "../../cm_shared/CMDeleteModal";
import ScenarioVersions from "./../ScenarioVersions";
import Modal from "../../cm_shared/cm_global_modal";
import RemoveCircleIcon from "@material-ui/icons/RemoveCircle";
import CustomPagination from "../../cm_shared/CMCustomPagination";
import AlertBox from "../../cm_shared/Reporting/AlertBox/AlertComponent"
import { LoadingContext } from "../../../../context/spinnerContext";
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Button
} from "@material-ui/core";

let baseUrl = "data:image/png;base64,";

const customStyles = {
  rows: {
    style: {
      minHeight: "unset",
      cursor: "pointer",
      fontSize: 16,
      paddingTop: "10px",
      paddingBottom: "10px",
    },
  },
  headCells: {
    style: {
      padding: "8px",
      // backgroundColor: "#b0ff45",
      justifyContent: "flex-start",
    },
  },
  cells: {
    style: {
      paddingLeft: "8px",
      paddingRight: "8px",
      fontWeight: "bold",
      justifyContent: "flex-start",
    },
  },
};
const SelectedScenarioVariations = (props) => {
  console.log("prop", props);
  const [selectedRows, setSelectedRows] = useState([]);
  const [variationData, setVariationData] = useState([]);
  const [deleteScenarioUuid, setDeleteScenarioUuid] = useState(null);
  const [disableEscapeKeyDown, setDisableEscapeKeyDown] = useState(false);
  const [disableBackdropClick, setDisableBackdropClick] = useState(false);
  const [modalContent, setModalContent] = useState(null);
  const [isOpen, setIsOpen] = useState(false);
  const [eventsPerPage, setEventsPerPage] = useState(10);
  const [page, setPage] = useState(0);
  const [columns, setColumns] = useState([]);
  const [sortField, setSortField] = useState("")
  const [sortOrder, setSortOrder] = useState("")
  const { setIsLoading } = useContext(LoadingContext);
  const [total, setTotal] = useState(0);
  const rowsPerPageSessionBased = [
    10, 50, 100, 500, 1000, 1500, 2000, 2500, 3000, 3500, 4000, 4500, 5000,
  ];
  const [confirmDeleteOpen, setConfirmDeleteOpen] = useState(false);
  const [statusQuote, setStatusQuote] = useState(null)
  const AlertBoxContainer = useMemo(
    () =>
      statusQuote ? (
        <AlertBox
          text={statusQuote.message}
          severity={!statusQuote.isError}
        />
      ) : null,
    [statusQuote]
  );
  const handleModal = (content, disableBackdropClick, disableEscapeKeyDown) => {
    setDisableBackdropClick(disableBackdropClick ? true : false);
    setDisableEscapeKeyDown(disableEscapeKeyDown ? true : false);
    setModalContent(content);
    setIsOpen(true);
  };
  const handleChangeRowsPerPage = (event) => {
    setEventsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };
  const handlePageChange = (event, newPage) => {
    setPage(newPage);
  };
  const handleSort = (column, direction) => {
    setSortField(column.selector);
    setSortOrder(direction);
  };
  const handleDownload = async (row) => {
    setIsLoading(true);
    if (window.location.hostname === "localhost") {
      const fileToDownload = await axios.post(
        "cm_close_loop/cm_scenario_download",
        {
          scenario_uuid: row.scenario_uuid,
        }
      );
      const url = window.URL.createObjectURL(new Blob([fileToDownload.data]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute(
        "download",
        fileToDownload.headers["content-disposition"].split("filename=")[1]
      );
      document.body.appendChild(link);
      link.click();
    } else {
      const fileToDownload = await axios.post(
        "/generate-presigned-url",
        {
          s3_location: row.scenario_path,
        }
        // { responseType: "blob" }
      );
      window.open(fileToDownload.data.presigned_url);
    }
    setIsLoading(false);
  };
  const handleModalClose = () => {
    setIsOpen(false);
  };
  const handleDelete = async (scenarioUuid) => {
    console.log("scenarioUUis", scenarioUuid);

    try {
      setStatusQuote(null)
      setConfirmDeleteOpen(false);
      setIsLoading(true);
      const response = await axios.post(`/cm/close_loop/delete-carmaker-base-scenario-collection`, scenarioUuid);
      fetchSelectedScenarioVariations();
      setStatusQuote({ message: response.data.status_message, isError: false })
    } catch (error) {
      console.error("Failed to delete the scenario:", error);
      if (error && error.response.data.message)
        setStatusQuote({ message: error.response.data.message, isError: true })
      else
        setStatusQuote({ message: "Error Occured", isError: true })
    } finally {
      setConfirmDeleteOpen(false);
      setIsLoading(false);
    }
  };
  const handleChange = async (event) => {
    const newRow = event.selectedRows;
    if (variationData.length === newRow.length || event.allSelected) {
      props.onSelectAllRow(newRow, selectedRows);
    } else if (newRow.length === 0 && !event.allSelected) {
      props.onDeselectAllRow(selectedRows);
    } else if (newRow.length !== selectedRows.length) {
      if (newRow.length < selectedRows.length) {
        const deSelectedArr = selectedRows.filter(
          (obj1) =>
            !newRow.some((obj2) => obj2.scenario_uuid === obj1.scenario_uuid)
        );
        if (deSelectedArr.length > 0) props.onSelectRow(deSelectedArr[0], true);
        else props.onSelectRow(selectedRows[0], true);
      } else newRow.length > 0 && props.onSelectRow(newRow[0]);
    }
    setSelectedRows(event.selectedRows);
  };

  const setPreselectedRow = (res) => {
    if (props.itemsForBulkDownload.length > 0) {
      const newSelectedRow = res.data.filter((item) =>
        props.itemsForBulkDownload.find(
          (obj) => obj.scenario_uuid === item.scenario_uuid
        )
      );
      setSelectedRows(newSelectedRow);
    }
  };

  const initialColumns = [
    {
      name: "Scenario Variation Name",
      selector: "scenario_name",
      sortable: true,
      cell: (row) => (
        <div style={{ flexWrap: "wrap" }}>
          {row.scenario_name.split(".zip")[0]}
        </div>
      ),
    },
    {
      name: "Variation Details",
      selector: "catalogued_data",
      sortable: false,
      cell: (row) => (
        <div style={{}}
        >
          {Object.keys(row.catalogued_data).map((catalogued_data_value) => {
            return (
              // JSON.stringify(catalogued_data_value)
              <div style={{}}>
                <strong>{catalogued_data_value} </strong>
                <span>
                  {row.catalogued_data[catalogued_data_value].value
                    ? row.catalogued_data[catalogued_data_value].value +
                    row.catalogued_data[catalogued_data_value].unit
                    : row.catalogued_data[catalogued_data_value]}{" "}
                </span>
              </div>
            );
          })}
        </div>
      ),
    },
    {
      name: "Representation",
      selector: "scenarioVariationRepresentation",
      sortable: false,
      cell: (row) => (
        <div style={{ flexWrap: "wrap" }}>
          <img
            src={
              row.representation.startsWith("https://")
                ? row.representation
                : `${baseUrl}${row.representation.replace(/['"]+/g, "")}`
            }
            alt=""
            style={{ cursor: "pointer", padding: "10px" }}
            width="100"
            height="100"
          ></img>
        </div>
      ),
    },
    {
      name: "Updated On",
      selector: "updated_at",
      sortable: true,
      cell: (row) => <div style={{ flexWrap: "wrap" }}>{row.updated_at}</div>,
    },
    {
      name: "Actions",
      selector: "actions",
      sortable: false,
      width: "200px",
      cell: (row) => {
        const isInCart = props.cartItemsForGroup.some(
          (item) => item.scenario_uuid === row.scenario_uuid
        );
        return (
          <div style={{ display: "flex", justifyContent: "space-around" }}>
            <Tooltip
              placement="top"
              title={
                isInCart ? <h6>Remove from Group</h6> : <h6>Add to Group</h6>
              }
            >
              <IconButton
                aria-label={isInCart ? "remove" : "add"}
                onClick={() =>
                  isInCart
                    ? props.handleRemoveFromCart(row)
                    : props.handleAddToCart(row)
                }
                style={{ marginLeft: '-1rem' }}
              >
                {isInCart ? <RemoveCircleIcon /> : <AddIcon />}
              </IconButton>
            </Tooltip>
            <Tooltip placement="top" title={<h6>Delete</h6>}>
              <IconButton
                aria-label="delete"
                onClick={() => {
                  setDeleteScenarioUuid({
                    scenario_uuid: row.scenario_uuid,
                    scenario_name: row.scenario_name,
                    scenario_version: row.scenario_version,
                  });
                  setConfirmDeleteOpen(true);
                }}
              >
                <DeleteIcon />
              </IconButton>
            </Tooltip>
            <Tooltip placement="top" title={<h6>Download</h6>}>
              <IconButton
                aria-label="download"
                disabled={row.scenario_path === null || row.scenario_path === ''}
                onClick={() => handleDownload(row)}
              >
                <CloudDownloadIcon />
              </IconButton>
            </Tooltip>
            <Tooltip placement="top" title={<h6>Previous Versions</h6>}>
              <IconButton
                aria-label="download"
                onClick={() =>
                  handleModal(
                    <>
                      <ScenarioVersions
                        data={row}
                        handleClose={handleModalClose}
                      />
                    </>
                  )
                }
              >
                <HistoryIcon />
              </IconButton>
            </Tooltip>
          </div>
        );
      },
    },
  ];
  const fetchSelectedScenarioVariations = async () => {
    try{
    setIsLoading(true);
    const response = await axios.post(
      '/cm/close_loop/fetch-carmaker-scenario-by-variation',
      {
        page_number_record: page + 1,
        page_size_record: eventsPerPage,
        scenario_logical_name: props.data.scenario_logical_name,
        sort_field_record: sortField,
        sort_order_record: sortOrder,
        searchOptions: props.currentFiltersPassed ? props.currentFiltersPassed : {}

      }
    );
    setPreselectedRow(response.data);
    setVariationData(response.data.data);
    setTotal(response.data.total);
    }
    catch (error) {
      console.error(error)
      // setPreselectedRow({});
      // setVariationData([]);
      // setTotal(0);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    setColumns(initialColumns);
  }, [props.cartItemsForGroup]);

  useEffect(() => {
    fetchSelectedScenarioVariations();
  }, [eventsPerPage, page, sortField, sortOrder]);
  return (
    <>
      <Modal
        isOpen={isOpen}
        setIsOpen={setIsOpen}
        content={modalContent}
        size={"lg"}
        disableEscapeKeyDown={disableEscapeKeyDown}
        disableBackdropClick={disableBackdropClick}
      />

      <CustomPagination
        total={total}
        rowsPerPageOptions={rowsPerPageSessionBased}
        eventsPerPage={eventsPerPage}
        page={page}
        handleChangeRowsPerPage={handleChangeRowsPerPage}
        onPageChange={handlePageChange}
      />
      <div
        style={{
          margin: "50px",
          border: "solid 1px rgba(0,0,0,.5)",
          borderRadius: "10px",
          padding: "20px",
          axHeight: "500px",
          overflowY: "auto",
        }}
      >
        <DataTable
          selectableRows
          selectableRowDisabled={(row) => row.scenario_path === null || row.scenario_path === ''}
          onSelectedRowsChange={handleChange}
          selectableRowSelected={(row) =>
            selectedRows.some((obj) => obj.scenario_uuid === row.scenario_uuid)
          }
          clearSelectedRows={props.clearRows}
          columns={columns}
          onSort={handleSort}
          sortServer
          data={variationData}
          noDataComponent={"No Variations for the Selected Scenario"}
          customStyles={customStyles}
        ></DataTable>
      </div>
      {/* {AlertBoxContainer} */}
      <CMDeleteModal
        open={confirmDeleteOpen}
        message="Are you sure you want to delete this scenario?"
        onCancel={() => setConfirmDeleteOpen(false)}
        onConfirm={() => handleDelete(deleteScenarioUuid)}
      />
      <Dialog
        open={statusQuote}
        onClose={() => setStatusQuote(null)}
        aria-labelledby="dialog-title"
        aria-describedby="dialog-description"
      >
        <DialogContent>
          <DialogContentText id="dialog-description">
            {statusQuote && statusQuote.message}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setStatusQuote(null)} color="primary">
            Ok
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default SelectedScenarioVariations;
